<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="400px"
    @close="changeVisible"
  >
    <span>{{content}}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="saveAndOpen" size="small" type="primary">{{buttonText1}}</el-button>
      <el-button @click="cancelAndOpen" size="small" type="warning">{{buttonText2}}</el-button>
      <el-button @click="cancelAndClose" size="small" >{{buttonText3}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "closeTips",
    props:['show','openTips'],
    data(){
      return{
        title:'提示',
        dialogVisible:false,
        content:'是否先保存已打开流程，再执行打开操作？',
        buttonText1:'保存',
        buttonText2:'不保存',
        buttonText3:'取消',
      }
    },
    methods:{
      saveAndOpen() {
        this.$emit('closeAction',true,true,this.openTips)
        this.dialogVisible = false
      },
      cancelAndOpen() {
        this.$emit('closeAction',false,true,this.openTips)
        this.dialogVisible = false
      },
      cancelAndClose() {
        this.$emit('closeAction',false,false,this.openTips)
        this.dialogVisible = false
      },
      changeVisible(val) {
        this.$emit('closeTips',false)
      }
    },
    watch:{
      show:{
        deep:true,
        handler(val) {
          this.dialogVisible = val
        }
      },
      openTips:{
        deep:true,
        handler(val) {
          if (this.openTips) {
            this.content = '是否先保存已打开流程，再执行打开操作？'
            this.buttonText1 = '保存'
            this.buttonText2 = '不保存'
            this.buttonText3 = '取消'
          } else {
            this.content = '是否先保存当前流程，再执行关闭操作？'
            this.buttonText1 = '保存'
            this.buttonText2 = '不保存'
            this.buttonText3 = '取消'
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/flow/closeTips.vue